import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { KICKSTART_RESPONSES } from 'utils/constants/collectionNames';
import {
  GET_KICKSTART_RESPONCE_SUCCEED,
  GET_KICKSTART_RESPONCE_ERROR,
  LOADING_STATE
} from './types';

export const getKickstartResponce = clientId => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = firestore.collection(KICKSTART_RESPONSES).doc(clientId);
  dispatch({
    type: LOADING_STATE
  });
  docRef
    .get()
    .then(doc => {
      dispatch({
        type: GET_KICKSTART_RESPONCE_SUCCEED,
        payload: doc.data()
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_KICKSTART_RESPONCE_ERROR,
        payload: `error: ${err}`
      });
    });
};
